import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {autoLogin} from './modules/auth/state/auth.actions';
import {EncryptService} from './services/encrypt.service';
import {AppState} from "./store/app.state";
import {getErrorMessage, getLoading} from "./store/shared/shared.selector";
import {AuthenticationService} from "./services/authenticate.service";
import {LocalStorageService} from "./services/local-storage.service";
import {SwUpdate} from '@angular/service-worker';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
    title = this.translate.instant('common.name');
    
    showLoading!: Observable<boolean>;
    errorMessage!: Observable<string>;
    
    constructor(private readonly store: Store<AppState>,
                private readonly translate: TranslateService,
                private readonly encryptService: EncryptService,
                private readonly authenticationService: AuthenticationService,
                private readonly localStorageService: LocalStorageService,
                private readonly swUpdate: SwUpdate) {
    }
    
    ngOnInit() {
        const keys = this.localStorageService.getEncryptKeys();
        this.encryptService.genKeys(keys);
        if (keys == null) {
            this.localStorageService.setEncryptKeys({
                k: this.encryptService.clientPrivateKey,
                p: this.encryptService.clientPublicKey,
            })
        }
        
        this.showLoading = this.store.select(getLoading);
        this.errorMessage = this.store.select(getErrorMessage);
        this.store.dispatch(autoLogin());
        
        if (this.swUpdate.isEnabled) {
            // Kiểm tra khi có bản cập nhật mới
            this.swUpdate.available.subscribe((event) => {
                console.log('Bản cập nhật mới đã sẵn sàng', event);
                this.swUpdate.activateUpdate().then(() => document.location.reload());
            });
            
            // Kiểm tra khi Service Worker đã được kích hoạt
            this.swUpdate.activated.subscribe((event) => {
                console.log('Service Worker đã được kích hoạt', event);
            });
        }
    }
}
